/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';

@Component({
  selector: 'app-reset-password',
  imports: [ReactiveFormsModule, CommonModule, HeaderComponent],
  templateUrl: './reset-password.component.html', 
  styleUrls: ['../login/login.component.scss'] // Reusing login styles
})
export class ResetPasswordComponent {
  resetPasswordForm: FormGroup;
  isLoading = false;
  message = '';

  constructor(private fb: FormBuilder, private router: Router, private authService: AuthService) {
    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]]
    }, { validator: this.passwordMatchValidator });
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password');
    const confirmPassword = form.get('confirmPassword');
    return password && confirmPassword && password.value === confirmPassword.value ? null : { mismatch: true };
  }

  async onSubmit() {
    if (this.resetPasswordForm.invalid) return;

    this.isLoading = true;
    const { password } = this.resetPasswordForm.value;
    const { data, error } = await this.authService.updateUserPass(password);

    this.isLoading = false;
    if (error) {
      this.message = `Error: ${error.message}`;
    } else {
      this.message = 'Password updated successfully! Redirecting...';
      setTimeout(() => this.router.navigate(['/login']), 3000);
    }
  }
}